export default "__VITE_ASSET__CXi0LX9q__"